import { Component, Inject, NgZone, OnInit } from '@angular/core';
import OAuthLoadingView from './oauth-loading.component.html';

@Component({
    selector: 'auth-oauth-loading',
    template: OAuthLoadingView
})
export class OAuthLoadingComponent implements OnInit {

    hasError = false;
    errorMessage = '';

    constructor(
        @Inject('LoginService') private loginService: any,
        @Inject('$state') private $state: any,
        @Inject(NgZone) private ngZone: NgZone
    ) {}

    ngOnInit(): void {
        this.loginService.nextStep()
            .then((step: any) => {
                // undefined = 202: getAuthInfo() already navigating to dashboard
                if (step !== undefined) {
                    // null (no valid process) or a step object (more auth steps) → go to login
                    this.ngZone.run(() => this.$state.go('authinit'));
                }
            })
            .catch((err: any) => {
                this.ngZone.run(() => {
                    this.hasError = true;
                    this.errorMessage = err?.data?.message || 'Error al verificar el acceso. Inténtalo de nuevo.';
                });
            });
    }

    goBackToLogin(): void {
        this.ngZone.run(() => this.$state.go('authinit'));
    }
}
